export default "__VITE_ASSET__Dqqvv70W__"